import type { HomeItem, HomePrescriptionItem } from 'src/app/types';

/**
 * Filters an array of HomeItems and returns an array of
 * pending transfers as HomePrescriptionItems
 * @param {Array} homeItems
 * @returns {Array}
 */
export function filterPendingTransfersFromHomeItems(homeItems: HomeItem[]): HomePrescriptionItem[] {
  if (!homeItems) return [];
  return homeItems.reduce((allMeds, patients) => {
    return allMeds.concat(
      patients.items?.filter(item => {
        return item.status === 'pending' && item.type === 'transfer';
      })
    );
  }, []);
}
/**
 * Takes an array of HomeItems and
 * returns an array of HomePrescriptionItems
 *
 * @param {Array} homeItems
 * @returns {Array}
 */
export function flattenPrescriptionItems(homeItems: HomeItem[]): HomePrescriptionItem[] {
  if (!homeItems) return [];
  return homeItems.reduce((allMeds, patients) => {
    return allMeds.concat(patients.items);
  }, []);
}
